import { render } from "./ExpedientDetailChangeMediaCategory.vue?vue&type=template&id=1c7b81b6"
import script from "./ExpedientDetailChangeMediaCategory.vue?vue&type=script&lang=js"
export * from "./ExpedientDetailChangeMediaCategory.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__